<div class="vtr-widget-schedule-scan">
		<div class="container-fluid">
			<div class="row">
				<div class="col">
					<div class="title">{{title}}</div>
					<div class="description">{{description}}</div>
				</div>
			</div>
			<div class="row">
				<div class="col">
					<div class="settings-container" [ngClass]= "{'force-scroll': items.length > 3}" *ngIf="items.length">
						<vtr-ui-list-scheduled-scan *ngFor="let item of items"
							[title]="item.name"
							[typeScan]="item.scanType"
							[scanID]="item.deleteReq.taskID"
							(editClick)="editScanFromList($event)">
						</vtr-ui-list-scheduled-scan>
					</div>
					<div class="button-row">
						<vtr-material-button
							[label]="buttonText | uppercase"
							[isDisabled]="disable()"
							[tooltipText] ="buttonText"
							(buttonClick)="onScheduleScanModal(false)"
							heightSize="lg">
						</vtr-material-button>
					</div>
				</div>
			</div>
		</div>
	</div>

